module.exports = __webpack_public_path__ + "static/media/anc7ru.a0da5324.pdf";